import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import api from "../lib/api";

export function EnquiryDialog({ open, onOpenChange, product }) {
  const [form, setForm] = useState({ name: "", business: "", phone: "", email: "", colour: "", size: "", quantity: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("Please enter your name and phone number");
      return;
    }
    setLoading(true);
    try {
      await api.post("/enquiries", {
        ...form,
        product: product?.name || "",
        source: "quote_dialog",
      });
      toast.success("Enquiry sent! Our team will reach out shortly.");
      onOpenChange(false);
      setForm({ name: "", business: "", phone: "", email: "", colour: "", size: "", quantity: "", message: "" });
    } catch {
      toast.error("Could not send enquiry. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="quote-enquiry-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-[#0B1B3D]">Get a Wholesale Quote</DialogTitle>
          <DialogDescription>
            {product ? `Enquiry for ${product.name}` : "Tell us what you need and we'll get back with pricing."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-3">
          <div className="grid gap-3 sm:grid-cols-2">
            <div>
              <Label>Name *</Label>
              <Input data-testid="quote-input-name" value={form.name} onChange={set("name")} placeholder="Your name" />
            </div>
            <div>
              <Label>Business</Label>
              <Input data-testid="quote-input-business" value={form.business} onChange={set("business")} placeholder="Company / shop" />
            </div>
            <div>
              <Label>Phone *</Label>
              <Input data-testid="quote-input-phone" value={form.phone} onChange={set("phone")} placeholder="Phone number" />
            </div>
            <div>
              <Label>Email</Label>
              <Input data-testid="quote-input-email" type="email" value={form.email} onChange={set("email")} placeholder="For a confirmation reply" />
            </div>
            <div>
              <Label>Quantity</Label>
              <Input data-testid="quote-input-quantity" value={form.quantity} onChange={set("quantity")} placeholder="e.g. 50 pcs / 2 rolls" />
            </div>
            <div>
              <Label>Colour</Label>
              <Input data-testid="quote-input-colour" value={form.colour} onChange={set("colour")} placeholder="Preferred colour" />
            </div>
            <div>
              <Label>Size</Label>
              <Input data-testid="quote-input-size" value={form.size} onChange={set("size")} placeholder="Preferred size" />
            </div>
          </div>
          <div>
            <Label>Message</Label>
            <Textarea data-testid="quote-input-message" value={form.message} onChange={set("message")} placeholder="Any details..." rows={3} />
          </div>
          <Button type="submit" disabled={loading} data-testid="quote-submit-button"
            className="mt-1 bg-[#10B981] font-semibold hover:bg-[#059669]">
            {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Send className="mr-2 h-4 w-4" />}
            Send Enquiry
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
